<!-- `.ps-panel` (P/proto-states.js:48): disc, h3, p, `.ps-acts`, the retry `.ps-note`, `.ps-foot`. -->
<div class="agu-state" [class.agu-state--error]="Variant === 'error'" [class.agu-state--lock]="Variant === 'lock'">
    <span class="agu-state__icon" aria-hidden="true"><agu-icon [Name]="Icon" [Size]="20" /></span>
    <h3 class="agu-state__title">{{ Title }}</h3>
    @if (Body) {
        <p class="agu-state__body">{{ Body }}</p>
    }
    @if (PrimaryLabel || SecondaryLabel) {
        <div class="agu-state__acts">
            @if (PrimaryLabel) {
                <button type="button" class="agu-state__btn" (click)="OnPrimary()">{{ PrimaryLabel }}</button>
            }
            @if (SecondaryLabel) {
                @if (SecondaryHref) {
                    <a class="agu-state__btn agu-state__btn--q" [href]="SecondaryHref">{{ SecondaryLabel }}</a>
                } @else {
                    <button type="button" class="agu-state__btn agu-state__btn--q" (click)="OnSecondary()">{{ SecondaryLabel }}</button>
                }
            }
        </div>
    }
    @if (Note) {
        <div class="agu-state__note" role="status">{{ Note }}</div>
    }
    @if (Foot) {
        <div class="agu-state__foot">{{ Foot }}</div>
    }
</div>
